import { Spacer } from '@dot/design-system';
import { VerificationResult as VerificationResultEnum } from '@repo/common';

import { ColorVariant, Container, SuccessIcon, Text, Title } from '../components';
import { useResultText } from '../hooks/use-result-text';

import { useAppContext } from '@/providers/app-provider/context';

export const VerificationSuccess = () => {
  const { state } = useAppContext();
  const text = useResultText(VerificationResultEnum.SUCCESS);

  return (
    <Container>
      <SuccessIcon />
      <Title $colorVariant={ColorVariant.SUCCESS} id="verification-result-title">
        {text.title}
      </Title>
      <Text id="verification-result-subtitle">{text.subtitle}</Text>
      {state.verificationOnMobile && text.mobileRedirectInfo && (
        <Spacer $top={2}>
          <Text>{text.mobileRedirectInfo}</Text>
        </Spacer>
      )}
    </Container>
  );
};
